import { types as t } from 'mobx-state-tree';
import { FileInfo } from '../../question-data-model/Script/abtract-script.store';

export const SentenceLearnHistory = t.model('SentenceLearnHistory', {
  type: t.maybeNull(t.string),
  key: t.maybeNull(t.number),
  correctPercentage: t.maybeNull(t.number),
  marked: t.maybeNull(t.string),
  userAnswer: t.array(t.string),
  speech: t.maybeNull(FileInfo),
});
